// src/pages/ForgotPassword.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Box, Button, TextField, Typography, Stack, Alert, CircularProgress, Paper,
} from "@mui/material";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import EmailIcon       from "@mui/icons-material/Email";
import ArrowBackIcon   from "@mui/icons-material/ArrowBack";
import API from "../api";
import { indigoGradient, C } from "../theme";

export default function ForgotPassword() {
  const [value,   setValue]   = useState("");
  const [sent,    setSent]    = useState(false);
  const [error,   setError]   = useState("");
  const [loading, setLoading] = useState(false);

  // Accepte email ou nom d'utilisateur
  const isEmail = value.includes("@");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!value.trim()) return;
    setError(""); setLoading(true);
    try {
      await API.post("/auth/forgot-password", isEmail
        ? { email: value.trim() }
        : { username: value.trim() }
      );
      setSent(true);
    } catch {
      // On affiche toujours le message de succès (anti-énumération)
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight:"78vh", display:"flex", alignItems:"center", justifyContent:"center" }}>
      <Box sx={{ width:"100%", maxWidth:400 }}>
        <Box sx={{ textAlign:"center", mb:4 }}>
          <Box sx={{ width:54, height:54, borderRadius:3, mx:"auto", mb:2,
            background:indigoGradient, display:"flex", alignItems:"center", justifyContent:"center" }}>
            <AutoStoriesIcon sx={{ color:"white", fontSize:26 }} />
          </Box>
          <Typography variant="h4" fontWeight={700}>Mot de passe oublié</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt:.5 }}>
            Entrez votre email ou nom d'utilisateur
          </Typography>
        </Box>

        <Paper sx={{ p:4, borderRadius:"16px" }}>
          {sent ? (
            <Stack spacing={2.5} alignItems="center">
              <Box sx={{ width:56, height:56, borderRadius:"50%", background:"#dcfce7",
                display:"flex", alignItems:"center", justifyContent:"center" }}>
                <EmailIcon sx={{ color:"#16a34a", fontSize:28 }} />
              </Box>
              <Alert severity="success" sx={{ width:"100%", borderRadius:"8px" }}>
                Si ce compte existe, un email de réinitialisation a été envoyé.
                Vérifiez votre boîte mail (et les spams).
              </Alert>
              <Button component={Link} to="/login" startIcon={<ArrowBackIcon />}
                variant="outlined" fullWidth sx={{ borderRadius:"8px", textTransform:"none" }}>
                Retour à la connexion
              </Button>
            </Stack>
          ) : (
            <Box component="form" onSubmit={handleSubmit}>
              <Stack spacing={2.5}>
                {error && <Alert severity="error" sx={{ borderRadius:"8px" }}>{error}</Alert>}
                <TextField
                  label="Email ou nom d'utilisateur"
                  fullWidth required autoFocus
                  value={value}
                  onChange={e => setValue(e.target.value)}
                  autoComplete="email"
                  helperText="Nous enverrons un lien de réinitialisation à l'adresse email associée à ce compte."
                />
                <Button type="submit" variant="contained" size="large" fullWidth
                  disabled={loading || !value.trim()}
                  sx={{ py:1.3, mt:.5, borderRadius:"8px" }}>
                  {loading ? <CircularProgress size={20} color="inherit" /> : "Envoyer le lien"}
                </Button>
                <Typography variant="body2" sx={{ textAlign:"center", color:"text.secondary" }}>
                  <Link to="/login"
                    style={{ color:C.indigo[600], fontWeight:600, textDecoration:"none" }}>
                    ← Retour à la connexion
                  </Link>
                </Typography>
              </Stack>
            </Box>
          )}
        </Paper>
      </Box>
    </Box>
  );
}
